import React from 'react';
import { Instagram } from 'lucide-react';
import SetaLogo from './SetaLogo';
import { contactInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#0e0e0e] text-white">
      <div className="py-14 px-6">
        <div className="max-w-[1100px] mx-auto text-center">
          <h3 className="text-white text-[22px] md:text-[26px] font-bold tracking-tight mb-2" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Redes Sociais
          </h3>
          <div className="mx-auto w-20 h-[3px] bg-[#C99A36] mb-8" />

          <a
            href={contactInfo.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-white/90 hover:text-[#E8C16A] transition-colors"
          >
            <Instagram size={26} strokeWidth={1.5} />
            <span className="text-[15px] font-semibold tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {contactInfo.instagram}
            </span>
          </a>
          <p className="mt-4 text-white/70 text-[13px] tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
            Siga e acompanhe as novidades da SETA no Instagram.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1300px] mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <SetaLogo height={42} variant="dark" />
          <p className="text-white/60 text-[12px] tracking-wide" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            © {new Date().getFullYear()} SETA Administração e Consultoria. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
